import { eReducerStatusBase } from "../eReducerStatusBase";
import { IMauPhieuThuCauHinh, IMauPhieuThuCauHinhCreateRequest, IMauPhieuThuCauHinhUpdateRequest } from "../../../model/respone/category/IMauPhieuThuCauHinh";

export interface IMauPhieuThuCauHinhReducer {
  list: IMauPhieuThuCauHinh[];
  currentItem: IMauPhieuThuCauHinh | null;
  status: eReducerStatusBase;
  error: string | null;
  isShowEditModal: boolean;
  request: IMauPhieuThuCauHinhCreateRequest | null;
}

export const INITIAL_MAU_PHIEU_THU_CAU_HINH: IMauPhieuThuCauHinhReducer = {
  list: [],
  currentItem: null,
  status: eReducerStatusBase.is_completed,
  error: null,
  isShowEditModal: false,
  request: null,
};
